export default __webpack_public_path__ + "img/priority/low.svg";